import React, { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    CardTitle,
    Table,
    Spinner,
    Alert,
    Row,
    Col,
    Input,
    Button,
    Modal,
    ModalHeader,
    ModalBody
} from "reactstrap";

import { getAllUserLeaves, getHolidaysByYear, getLeaveSummary } from "../../Api/ApiUrlConst";
import { Link, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

interface LeaveSummary {
    userId: string;
    userName: string;
    sL_Total: number;
    sL_Used: number;
    sL_Extra: number;
    eL_Total: number;
    eL_Used: number;
}

const AdminLeaveSummary: React.FC = () => {

    const [data, setData] = useState<LeaveSummary[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const [year, setYear] = useState(new Date().getFullYear());
    const [selectedUsers, setSelectedUsers] = useState<string[]>([]);

    const [search, setSearch] = useState("");
    const [month, setMonth] = useState<number | "All">("All");
    const [department, setDepartment] = useState("All");

    const [selectedUser, setSelectedUser] = useState<any>(null);
    const [leaveDetails, setLeaveDetails] = useState<any[]>([]);
    const [modalOpen, setModalOpen] = useState(false);

    const filteredData = data.filter((item) => {
        const matchSearch = item.userName
            .toLowerCase()
            .includes(search.toLowerCase());


        return matchSearch;
    });




    const hiddenUsers = ["Perumal", "Manager", "Vishnu Prasath", "Rizalde Barrato", "Admin", "Limya",
        "Client", "SanthoshS", "SanthoshR", "-", "Gokul", "Muthu", "PriceWorth", "Krish", "	RavindraBabus", "Renganathan", "Limya Shilin",]
        .map(v => v.toLowerCase().trim());



    useEffect(() => {
        loadSummary();
    }, [year]);

    const loadSummary = async () => {
        setLoading(true);

        try {
            const res = await getLeaveSummary(year); // ✅ FIRST fetch data

            // ✅ THEN filter
            const filtered = res.filter((u: LeaveSummary) => {
                const name = (u.userName || "").toLowerCase().trim();
                return !hiddenUsers.includes(name);
            });

            setData(filtered); // ✅ set filtered data

        } catch {
            setError("Failed to load leave summary.");
        }

        setLoading(false);
    };

    

    
const exportToExcel = async () => {

  const exportData = filteredData.filter(d =>
    selectedUsers.includes(d.userId)
  );

  if (exportData.length === 0) {
    alert("Select at least one user");
    return;
  }

 let allLeaves: any[] = [];
let holidaySet = new Set<string>();

try {
  const [resLeaves, resHolidays] = await Promise.all([
    getAllUserLeaves(year),
    getHolidaysByYear(year)
  ]);

  allLeaves = resLeaves.data;

  // ✅ Convert holidays to YYYY-MM-DD format
  holidaySet = new Set(
    resHolidays.data.map((h: any) =>
      new Date(h.date).toISOString().split("T")[0]
    )
  );

} catch {
  alert("Failed to fetch leave/holiday data");
  return;
}

  // =========================
  // 🟢 Sheet 1 → Summary
  // =========================
  const summaryData = exportData.map((item, index) => ({
    "S.No": index + 1,
    "Employee": item.userName,
    "SL Total": item.sL_Total,
    "SL Used": item.sL_Used,
    "Extra SL": item.sL_Extra,
    "EL Total": item.eL_Total,
    "EL Used": item.eL_Used,
    "Remaining":
      (item.sL_Total - item.sL_Used) +
      (item.eL_Total - item.eL_Used)
  }));

  const ws1 = XLSX.utils.json_to_sheet(summaryData);

  ws1["!cols"] = [
    { wch: 6 }, { wch: 20 }, { wch: 10 },
    { wch: 10 }, { wch: 10 }, { wch: 10 },
    { wch: 10 }, { wch: 12 }
  ];

  // =========================
  // 🔵 Sheet 2 → Month-wise Pivot
  // =========================

  const months = [
    "Jan","Feb","Mar","Apr","May","Jun",
    "Jul","Aug","Sep","Oct","Nov","Dec"
  ];

  let detailsData: any[] = [];

  exportData.forEach((user) => {

    const userLeaves = allLeaves.filter(
      (l: any) => l.userID === user.userId
    );

    let monthMap: any = {};
    months.forEach(m => monthMap[m] = []);

userLeaves.forEach((leave: any) => {
  let current = new Date(leave.fromDate);
  const end = new Date(leave.toDate);

  while (current <= end) {
    const day = current.getDay(); // 0=Sun, 6=Sat

    const isoDate = current.toISOString().split("T")[0];

    // ✅ Skip weekends + holidays
    if (
      day !== 0 &&
      day !== 6 &&
      !holidaySet.has(isoDate)
    ) {
      const m = current.toLocaleString("default", { month: "short" });

      monthMap[m].push(
        current.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short"
        })
      );
    }

    current.setDate(current.getDate() + 1);
  }
});

    let row: any = {
      "User Name": user.userName
    };

    let total = 0;

    months.forEach(m => {
      row[m] = monthMap[m].length > 0
        ? monthMap[m].join(", ")
        : "";

      total += monthMap[m].length;
    });

    row["Total Leaves"] = total;

    detailsData.push(row);
  });

  const ws2 = XLSX.utils.json_to_sheet(detailsData);

  ws2["!cols"] = [
    { wch: 20 },
    ...months.map(() => ({ wch: 25 })),
    { wch: 15 }
  ];

  // =========================
  // 📘 Workbook
  // =========================
  const wb = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(wb, ws1, "Summary");
  XLSX.utils.book_append_sheet(wb, ws2, "User Month Report");

  // ✅ IMPORTANT (download file)
  XLSX.writeFile(wb, `Leave_Report_${year}.xlsx`);
};


    const handleUserClick = async (user: any) => {
        setSelectedUser(user);

        try {
            const res = await getAllUserLeaves(year);

            const userLeaves = res.data.filter(
                (l: any) => l.userID === user.userId
            );

            const months = [
                "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
            ];

            const grouped: any = {};
            months.forEach(m => grouped[m] = []);

            // ✅ LOOP EACH DATE RANGE
            userLeaves.forEach((leave: any) => {
                let current = new Date(leave.fromDate);
                const end = new Date(leave.toDate);

                while (current <= end) {
                    const month = current.toLocaleString("default", { month: "short" });

                    grouped[month].push(
                        current.toLocaleDateString("en-GB", {
                            day: "numeric",
                            month: "short"
                        })
                    );

                    current.setDate(current.getDate() + 1);
                }
            });

            const formatted = months.map((month) => ({
                month,
                count: grouped[month].length,
                dates: grouped[month]
            }));

            setLeaveDetails(formatted);
            setModalOpen(true);

        } catch {
            alert("Failed to load leave details");
        }
    };



    if (loading) {
        return (<div className="text-center mt-5"> <Spinner color="primary" /> </div>
        );
    }

    return (<div className="mt-4">


        <Card className="border-0 shadow-lg rounded-4">
            <CardBody className="p-4">

                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                        <h4 className="mb-0 fw-bold">Leave Summary</h4>
                        <small className="text-muted">Overview of employee leave usage</small>
                    </div>

                    <Row className="mb-3 align-items-center g-3">

                        {/* Search */}
                        <Col md={4}>
                            <Input
                                placeholder="🔍 Search employee..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                className="rounded-pill shadow-sm"
                            />
                        </Col>

                        {/* Year */}
                        <Col md={2}>
                            <Input
                                type="number"
                                value={year}
                                onChange={(e) => setYear(Number(e.target.value))}
                                className="rounded-pill shadow-sm"
                            />
                        </Col>

                        {/* Export Button */}
                        <Col md={3}>
                            <Button
                                color="success"
                                className="w-100 rounded-pill shadow-sm fw-semibold"
                                onClick={exportToExcel}
                            >
                                ⬇ Export Excel
                            </Button>
                        </Col>

                        {/* Back Button */}
                        <Col md={3}>
                            <Link to="/leave">
                                <Button
                                    color="light"
                                    className="w-100 rounded-pill shadow-sm"
                                >
                                    ← Back
                                </Button>
                            </Link>
                        </Col>

                    </Row>



                </div>

                {error && (
                    <Alert color="danger" className="rounded-3 shadow-sm">
                        {error}
                    </Alert>
                )}

                {/* Table */}
                <div className="table-responsive">

                    <Table className="align-middle table-hover border rounded-3 overflow-hidden">

                        <thead className="table-light">
                            <tr>
                                <th>
                                    <Input
                                        type="checkbox"
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setSelectedUsers(data.map((d) => d.userId));
                                            } else {
                                                setSelectedUsers([]);
                                            }
                                        }}
                                    />
                                </th>
                                <th>#</th>
                                <th>Employee</th>
                                <th>SL Total</th>
                                <th>SL Used</th>
                                <th>Extra SL</th>
                                <th>EL Total</th>
                                <th>EL Used</th>
                                <th>Total Rem</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filteredData.length === 0 && (
                                <tr>
                                    <td colSpan={7} className="text-center py-4 text-muted">
                                        No records found
                                    </td>
                                </tr>
                            )}

                            {filteredData.map((item, index) => (
                                <tr key={item.userId} className="hover-shadow">
                                    <td>
                                        <Input
                                            type="checkbox"
                                            checked={selectedUsers.includes(item.userId)}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setSelectedUsers([...selectedUsers, item.userId]);
                                                } else {
                                                    setSelectedUsers(selectedUsers.filter(id => id !== item.userId));
                                                }
                                            }}
                                        />
                                    </td>
                                    <td className="fw-semibold">{index + 1}</td>

                                    <td>
                                        <div
                                            className="fw-semibold text-primary"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleUserClick(item)}
                                        >
                                            {item.userName}
                                        </div>
                                    </td>

                                    <td>{item.sL_Total}</td>
                                    <td>{item.sL_Used}</td>

                                    <td>
                                        <span
                                            className={`badge rounded-pill px-3 ${item.sL_Extra > 0 ? "bg-danger-subtle text-danger" : "bg-light text-dark"
                                                }`}
                                        >
                                            {item.sL_Extra}
                                        </span>
                                    </td>

                                    <td>{item.eL_Total}</td>
                                    <td>{item.eL_Used}</td>
                                    <td>
                                        <span className="badge bg-success-subtle text-success px-3 py-2 rounded-pill">
                                            {(item.sL_Total - item.sL_Used) +
                                                (item.eL_Total - item.eL_Used)}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </Table>
                </div>

            </CardBody>
        </Card>

        <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} size="lg">
            <ModalHeader toggle={() => setModalOpen(false)}>
                {selectedUser?.userName} - Leave Details
            </ModalHeader>

            <ModalBody>

                {leaveDetails.length === 0 && (
                    <div className="text-center text-muted">No leave data</div>
                )}

                {leaveDetails.map((m, index) => (
                    <div
                        key={index}
                        className="d-flex justify-content-between align-items-center border-bottom py-2"
                    >
                        <div style={{ width: "80px" }}>
                            <strong>{m.month}</strong>
                        </div>

                        <div style={{ width: "120px" }}>
                            {m.count > 0 ? (
                                <span className="badge bg-primary-subtle text-primary px-3">
                                    {m.count} leave
                                </span>
                            ) : (
                                <span className="text-muted">No leave</span>
                            )}
                        </div>

                        <div className="text-muted small flex-grow-1">
                            {m.dates.length > 0 ? m.dates.join(", ") : "-"}
                        </div>
                    </div>
                ))}

                {/* Total */}
                <div className="mt-3 text-end fw-bold">
                    Total Leaves:{" "}
                    {leaveDetails.reduce((sum, m) => sum + m.count, 0)}
                </div>

            </ModalBody>
        </Modal>

    </div>


    );
};

export default AdminLeaveSummary;
